export enum CLUSTER_ROUTE_NAMES {
  CLUSTER_INDEX = "cluster-index",
  CLUSTER_NEW = "cluster-new",
  CLUSTER_INSTALL = "cluster-install",
}
